import { useDebounce } from 'usehooks-ts';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import PriceInput from 'components/price-input';
import { ButtonProps } from 'components/button';
import BaseScreen from 'components/base-screen';
import MeaningfulHeader from 'components/meaningful-header';

import useBoundStore from 'store';
import { RangeNumber } from 'lib/types';
import { RUBLE_SIGN } from 'lib/constants';
import useViewApartmentDealsButtonProps from 'hooks/use-view-apartment-deals-button-props';
import useApartmentsFilterLimitsOnboarding from 'api/hooks/use-apartment-filter-limits-onboarding';

import styles from './styles.module.scss';

const ChoosePriceRange: React.FC = () => {
  const navigate = useNavigate();

  const priceRange = useBoundStore((s) => s.priceRange);
  const setPriceRange = useBoundStore((s) => s.setPriceRange);

  const [lowerPrice, setLowerPrice] = useState(priceRange.min);
  const [upperPrice, setUpperPrice] = useState(priceRange.max);
  const [rangeError, setRangeError] = useState(false);

  const debouncedLowerPrice = useDebounce(lowerPrice);
  const debouncedUpperPrice = useDebounce(upperPrice);

  /* ------------------------------------------------------------------------------------ */

  useEffect(() => {
    let errored = false;
    const range: RangeNumber = {};

    if (debouncedLowerPrice) {
      range.min = debouncedLowerPrice;
    }

    if (debouncedUpperPrice) {
      range.max = debouncedUpperPrice;
      if (range.min && range.min > range.max) {
        errored = true;
        setRangeError(true);
      }
    }

    if (!errored) {
      setRangeError(false);
      setPriceRange(range);
    }
  }, [debouncedLowerPrice, debouncedUpperPrice, setPriceRange]);

  /* ------------------------------------------------------------------------------------ */

  const { filterLimits } = useApartmentsFilterLimitsOnboarding();

  const buttons: ButtonProps[] = [{ ...useViewApartmentDealsButtonProps(), variant: 'default' }];

  return (
    <BaseScreen
      padContent
      buttons={buttons}
      title='Подбор объектов'
      onBackButtonClick={() => navigate(-1)}
    >
      <div className={styles.container}>
        <MeaningfulHeader
          className={styles.header}
          header={`Цена, ${RUBLE_SIGN}`}
          motto='Укажите диапазон цены'
        />

        <PriceInput
          clearButton
          value={lowerPrice}
          onChange={(value) => setLowerPrice(Number(value))}
          autoFocus={lowerPrice === undefined}
          placeholder={'от'}
          error={rangeError ? 'Мин. цена должна быть меньше макс. цены' : ''}
        />
        <PriceInput
          clearButton
          value={upperPrice}
          onChange={(value) => setLowerPrice(Number(value))}
          placeholder={'до'}
          error={rangeError ? 'Макс. цена должна быть больше мин. цены' : ''}
        />
      </div>
    </BaseScreen>
  );
};

export default ChoosePriceRange;
